module.exports = __webpack_public_path__ + "img/add.7e144649.svg";